import Modal from "@mui/material/Modal";
import React from "react";

/**
 * Rmodal - Component that render a modal on page
 * @component
 */
const Rmodal: React.FC<propTypes> = (props) => {
    const { className, open, handleClose, hiddenBackdrop, children, toast, style } = props;
    const modalClassName = [
        "gtr-modal-root tw-font-prometo",
        className,
    ].filter(Boolean).join(" ");

    return (
        <>
            <Modal
                className={modalClassName}
                style={{ border: "none", ...style, zIndex: style?.zIndex ? style?.zIndex : 1199 }}
                open={open}
                onClose={handleClose}
                disableAutoFocus={true}
                slotProps={{
                    backdrop: {
                        hidden: hiddenBackdrop,
                        className: "tw-backdrop-blur-[2px] tw-transition-all tw-duration-300 tw-ease-gtr-smooth",
                        style: { background: "rgba(0, 0, 0, 0.5)" },
                    },
                }}
            >
                {children}
            </Modal>
            {toast}
        </>
    );
};

type propTypes = {
    className?: string | undefined;
    style?: React.CSSProperties;
    hiddenBackdrop?: boolean;
    open: boolean;
    handleClose?:
    | ((event: {}, reason: "backdropClick" | "escapeKeyDown") => void)
    | undefined;
    children: JSX.Element;
    toast?: JSX.Element;
};

export default Rmodal;
